import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { run } from "./labels";

const F = ({ label, children }) => <div className="space-y-1"><Label className="text-xs">{label}</Label>{children}</div>;

export const RettificaDialog = ({ x, emessi, onClose, onSaved }) => {
  const doc = x.tipo_doc === "RETTIFICA";
  const [voci, setVoci] = useState([]);
  const [f, setF] = useState({ rif_sal_id: doc ? x.rif_sal_id : emessi[0]?.id || "", tipo: "Q", riga_computo_id: "", quantita: "", prezzo: "", importo: "", descrizione: "", motivo: "" });
  const set = (k) => (e) => setF((o) => ({ ...o, [k]: e.target.value }));
  useEffect(() => { api.get(`/computi/${x.contratto.computo_id}/registro-effettivo/voci`).then((r) => setVoci(r.data)); }, [x.contratto.computo_id]);
  const ok = f.rif_sal_id && f.motivo.trim().length >= 3 && (f.tipo === "Q" ? f.riga_computo_id && Number(f.quantita) : Number(f.importo) && f.descrizione.trim());
  const salva = async () => {
    const body = { rif_sal_id: f.rif_sal_id, motivo: f.motivo, ...(f.tipo === "Q"
      ? { riga_computo_id: f.riga_computo_id, quantita: f.quantita, prezzo: f.prezzo === "" ? null : f.prezzo }
      : { importo: f.importo, descrizione: f.descrizione }) };
    const r = await run(() => api.post(`/sal-e5/${x.id}/rettifiche`, body), "Rettifica aggiunta");
    if (r) onSaved(r.data);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="rettifica-dialog">
        <DialogHeader>
          <DialogTitle>Rettifica di un SAL emesso</DialogTitle>
          <DialogDescription>Il SAL emesso resta invariato: la differenza (positiva o negativa) viene contabilizzata qui, con motivo e autore.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <F label="SAL rettificato"><select className="w-full border rounded-md h-9 px-2 text-sm" value={f.rif_sal_id} onChange={set("rif_sal_id")} disabled={doc} data-testid="rettifica-rif">
            {doc ? <option value={x.rif_sal_id}>{x.rif_sal}</option> : emessi.map((s) => <option key={s.id} value={s.id}>{s.etichetta}</option>)}</select></F>
          <F label="Tipo"><select className="w-full border rounded-md h-9 px-2 text-sm" value={f.tipo} onChange={set("tipo")} data-testid="rettifica-tipo">
            <option value="Q">Quantità di una voce</option><option value="E">Importo (rettifica economica)</option></select></F>
          {f.tipo === "Q" ? <>
            <F label="Voce"><select className="w-full border rounded-md h-9 px-2 text-sm" value={f.riga_computo_id} onChange={set("riga_computo_id")} data-testid="rettifica-voce">
              <option value="">Seleziona…</option>{voci.map((v) => <option key={v.id} value={v.id}>{v.num_ord} · {v.tariffa} · {v.descrizione.slice(0, 70)}</option>)}</select></F>
            <div className="grid grid-cols-2 gap-3">
              <F label="Quantità (+/−)"><Input type="number" step="any" value={f.quantita} onChange={set("quantita")} data-testid="rettifica-quantita" /></F>
              <F label="Prezzo (vuoto = quello del SAL rettificato)"><Input type="number" step="any" min="0" value={f.prezzo} onChange={set("prezzo")} data-testid="rettifica-prezzo" /></F>
            </div></> : <div className="grid grid-cols-2 gap-3">
            <F label="Importo € (+/−)"><Input type="number" step="0.01" value={f.importo} onChange={set("importo")} data-testid="rettifica-importo" /></F>
            <F label="Descrizione"><Input value={f.descrizione} onChange={set("descrizione")} data-testid="rettifica-descrizione" /></F></div>}
          <F label="Motivo"><Input value={f.motivo} onChange={set("motivo")} data-testid="rettifica-motivo" /></F>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="rettifica-annulla">Annulla</Button>
          <Button onClick={salva} disabled={!ok} data-testid="rettifica-salva">Aggiungi rettifica</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
